export default __webpack_public_path__ + "static/cw-df3579119a799dd7b7921a3bda79507e.jpg";